<template>
  <div class="multiBandSearch" @mouseenter="isMouseIn=true" @mouseleave="isMouseIn=false" :style="cssVar">
    <el-popover
        ref="popover"
        placement="bottom-start"
        :visible-arrow="false"
        :popper-class="'multiband_popover multiband_popover'+uniqueClassId"
        trigger="click"
        @show="isShowList=true"
        @hide="isShowList=false"
        @after-enter="afterShow">
      <div class="default_area" v-show="isShowList">
        <div class="haveData" v-show="true">
          <div class="search">
            <el-input
                size="mini"
                placeholder="请输入内容"
                prefix-icon="kdfont kdfont-f"
                v-model="searchText"
                @change="searchTask"
            >
            </el-input>
          </div>
          <div class="check_box">
            <el-checkbox-group v-model="checkList" v-show="taskListShow.length>0">
              <el-checkbox v-for="(item,index) in taskListShow" :label="item"></el-checkbox>
            </el-checkbox-group>
            <div class="noData" v-show="taskListShow.length === 0">搜索结果为空</div>
          </div>
          <div class="selected">已选 <span>{{ checkList.length }}</span> 项</div>
        </div>
        <div class="noData" v-show="false">暂无可选数据</div>
      </div>
      <div slot="reference" :class="'input_area input_area'+uniqueClassId">
        <div class="text_area">
          <div class="text_item" v-for="(item,index) in checkList">
            <span class="text">{{item}}</span>
            <span class="kdfont kdfont-guanbi8" @click.stop="deleteItem(item)"></span>
          </div>
        </div>
        <div class="kdfont kdfont-xiala" :class="{'rotate':isShowList}"></div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    invoke: Function,
    taskList:Array,
    updateTaskList:Array,
    initSelected:Array,
    getSelected:String,
    themeNum:String
  },
  computed: {
    cssVar() {
      return {
        '--color': this.themeNum,
      }
    }
  },
  watch: {
    taskList: function (value) {
       this.taskListShow = value;
       this.relocation();
    },
    updateTaskList:function (value){
      this.taskList = value;
    },
    initSelected:function (value){
      this.checkList = value;
    },
    getSelected:function (value){
      if(value.includes('true')){
        this.invoke("selectedData",this.checkList);
      }
      this.checkList = [];
      this.taskList = this.taskListShow = [];
      this.searchText = '';
    }
  },
  filters: {
    formatDate(val) {

    },
  },
  data() {
    return {
      checkList:[],
      taskListShow:[],
      searchText:"",
      isShowList:false,
      isMouseIn:false,
      uniqueClassId:0
    }
  },
  mounted() {
      this.taskListShow = this.taskList;
      this.uniqueClassId = Math.floor(Math.random()*10000);
  },
  methods: {
    deleteItem(value){
      let num = this.checkList.indexOf(value);
      this.checkList.splice(num,1)
    },
    searchTask(){
      this.invoke("searchKey",this.searchText);
      // let newList = [];
      // for(let i in this.taskList){
      //   if(this.taskList[i].includes(this.searchText)){
      //     newList.push(this.taskList[i])
      //   }
      // }
      // this.taskListShow = newList;
    },

    /**
     * 重新定位级联弹框
     */
    relocation(){
      this.$nextTick(() => {
        this.$refs.popover.updatePopper();
      })
    },

    afterShow(){
      let eleS = $(".multiband_popover" + this.uniqueClassId);
      //设置弹框宽度为输入框等宽
      eleS.width( $('.input_area' + this.uniqueClassId).width());
      //给弹框植入主题色
      for (let i = 0, len = eleS.length; i < len; i++) {
        eleS[i].style.setProperty('--color',this.themeNum);
      }
    }
  }
}
</script>
<style lang="less">
.multiBandSearch{
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  .input_area{
    display: flex;
    align-items: center;
    height: 26px;
    flex-shrink: 0;
    border-bottom: 1px solid #999;
    .text_area{
      flex-shrink: 1;
      flex-grow: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      .text_item{
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #212121;
        margin-right: 5px;
        .kdfont{
          color: #5582F3;
          color: var(--theme-color);
          font-size: 14px;
          display: none;
        }
        &:hover>.kdfont{
          display: inline;
        }
      }
    }
    .kdfont-xiala{
      transition: transform .2s ease,-webkit-transform .2s ease;
    }
    .rotate{
      transform: rotate(180deg);
    }
  }
}
.multiband_popover{
  padding: 0 !important;
  margin-top: 6px !important;
  border: 0 !important;
  border-radius: 0 !important;
  -webkit-box-shadow: 0 1px 8px 0 rgba(0, 0, 0, .2) !important;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, .2) !important;
  background-color: #fff;
  min-width: 160px;
  -webkit-animation: q-hasJSd 1s steps(1) 0s 1 normal none !important;
  animation: q-hasJSd 1s steps(1) 0s 1 normal none !important;
  -webkit-transform-origin: 50% 0 !important;
  -ms-transform-origin: 50% 0 !important;
  transform-origin: 50% 0 !important;
  .default_area{
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-radius: 2px;

    .search{
      padding: 10px 10px 5px 10px;
    }
    .el-input {
      display: flex;
      input {
        flex-grow: 1;
        width: 100px;
        &:hover{
          border-color: #5582F3;
          border-color: var(--theme-color);
        }
        &:hover+.el-input__prefix>.el-input__icon{
          color:#5582F3;
          color: var(--theme-color);
        }
        &:focus{
          border-color: #5582F3;
          border-color: var(--theme-color);
        }
        &:focus+.el-input__prefix>.el-input__icon{
          color: #5582F3;
          color: var(--theme-color);
        }
      }
    }
    .check_box{
      display: flex;
      flex-direction: column;
      align-items: stretch;
      .el-checkbox-group{
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        max-height: 270px;
        .el-checkbox{
          margin: 0;
          padding: 0 12px 0 14px;
          height: 32px;
          line-height: 32px;
          overflow: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          .el-checkbox__label{
            font-size: 12px;
            padding-left: 5px;
            color: #212121 !important;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: calc(100% - 20px);
          }
          .el-checkbox__inner{
            border: 0 !important;
            font-size: 13px;
            color: #d9d9d9;
            font-family: kdfont !important;
            &::after{
              transform: none;
              position: initial;
              content: "\e9f1";
            }
          }
          &:hover{
            background: #f5f5f5;
          }
          .is-checked{
            .el-checkbox__inner{
              color: #5582F3;
              color: var(--theme-color);
              background: none !important;
              font-size: 13px;
              border: 0 !important;
              font-family: kdfont !important;
              &::after{
                transform: none;
                position: initial;
                content: "\e9f2";
              }
            }
          }
        }
      }
    }
    .selected{
      height: 32px;
      line-height: 32px;
      padding: 0 14px 0 12px;
      color: #999999;
      border-top: 1px solid #ccc;
      span{
        color: #5582F3;
        color: var(--theme-color);
      }
    }

  }
  .haveData{
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .noData{
    padding: 5px 0;
    text-align: center;
  }
}
</style>